import React from 'react';
export class Confirmation extends React.Component {

    render() {
        const serverResponse = this.props.serverResponse;
        const { info, pacote, tipoEvento, evento } = this.props.formData;
        const { pacoteSel, eventoSel, Total } = serverResponse;

        return (<form name="confirm" onSubmit={e => this.props.handleSubmit(e, serverResponse)}>
            <div id="info-confirm">
                <h1>Confirme os dados de sua inscrição:</h1>
                <ul>
                    {Object.keys(info).map(elem =>
                        <li><span className="title1"> {serverResponse[elem] === "" ? "(Vazio)" : serverResponse[elem]} </span> <span className="title2"> {elem} </span></li>
                    )}
                    <li><span className="title1"> {pacote[pacoteSel].nome} </span> <span className="title2"> Pacote </span></li>
                </ul>
            </div>

            {Object.keys(tipoEvento).filter(tE => eventoSel.map(e => evento[e].tipo).includes(tE)).map(tE => 
                <div id={`${tE}-confirm`} key={tE}>
                    <h1>{tE}</h1>
                    <ul>
                        {eventoSel.filter(e => evento[e].tipo === tE).map(e =>
                            <li key={e}><span className="title1"> {evento[e]["título"]} </span><span className="title2"> {evento[e]["título2"]} </span></li>
                        )}
                    </ul>
                </div>
            )}

            <div id="final-price-container">
                <span className="title2">Preço total: </span><span id="final-price" className="title1"> R$ {Total},00</span>
                <button onClick={e => this.props.voltar(serverResponse)}> Voltar e corrigir </button>
                <button value="submit" type="submit"> Continuar </button>
            </div>
        </form>);
    }
}
